import { Breadcrumb, Space, Typography, theme } from 'antd';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { type TicketRelation as TicketRelationType } from '../../model/types';

type Props = {
    ticketRelation: TicketRelationType;
};

function TicketTag({ ticketKey }: { ticketKey: string }) {
    const {
        token: { colorPrimary }
    } = theme.useToken();
    const {
        query: { ticketKey: ticketKeyOnUrl }
    } = useRouter();

    const { t } = useTranslation('common');

    const ticketText = `${t('ticket')} ${+(ticketKey?.split('-')?.[1] ?? null)}`;

    if (ticketKeyOnUrl === ticketKey) return <Typography style={{ color: colorPrimary }}>{ticketText}</Typography>;

    return <Link href={`/tickets/${ticketKey}`}>{ticketText}</Link>;
}

export default function TicketRelation({ ticketRelation }: Props) {
    const {
        token: { fontSizeXL }
    } = theme.useToken();
    const { t } = useTranslation('tickets');
    const { sourceTicket, targetTicket, type } = ticketRelation;

    const items = [
        { title: <TicketTag ticketKey={sourceTicket} /> },
        { title: <TicketTag ticketKey={targetTicket} /> }
    ];

    return (
        <Space align="baseline">
            <Typography.Text code>{t(`ticketRelation.${type}`)}</Typography.Text>
            <Breadcrumb
                items={items}
                separator={type === 'MERGE' ? <span style={{ fontSize: fontSizeXL, lineHeight: 0 }}>⊂</span> : '/'}
            />
        </Space>
    );
}
